import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';
import console from 'console';

function* fetchBrandImages(action: actionsInterfaces.IFetchBrandImagesAction) {
  let token: string;
  try {    
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimages`    
    if(action.query)callUrl=`${host}brandsimages?filter=${action.query}&start=${action.start}&pagelength=${action.length}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.update==="search") yield put(actions.brandsImages.setBrandImagesSearch(response.data));
      if (action.update==="section") yield put(actions.brandsImages.setBrandImagesSection(response.data));
      else yield put(actions.brandsImages.setBrandImages(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {    
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addBrandImages(action: actionsInterfaces.IPostBrandImagesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}brandsimage`, action.brandImages,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateBrandImages(action: actionsInterfaces.IUpdateBrandImagesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}brandsimage`,action.brandImages,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchBrandsVehicles(action: actionsInterfaces.IFetchBrandsVehiclesAction) {  
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    
    let callUrl=`${host}brandsimages/${action.year}/${action.make}/${action.model}/vehicles?trim=${action.trim}&type=${action.imgtype}&start=${action.start}&pagelength=${action.length}&oem=${action.oem??""}&search=${action.search??""}&userdata=${action.userdata}` 
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandImage(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* fetchBrandImage(action: actionsInterfaces.IFetchBrandImageAction) {
  let token: string;
  try {    
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimages/${action.id}`        
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandImage(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {    
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchBrandsVehiclesChromeData(action: actionsInterfaces.IFetchBrandsVehiclesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimages/${action.year}/${action.make}/${action.model}/vehicleschromedata?trim=${action.trim}&type=${action.imgtype}` 
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandImage(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchBrandsLogos(action: actionsInterfaces.IFetchBrandsLogosAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandslogos?oem=${action.oem}&logotype=${action.logotype}` 
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandLogos(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchBrandsImagesOem(action: actionsInterfaces.IFetchBrandsImagesOemAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimagesoem?oem=${action.oem}&imageType=${action.imageType}&metadata=${action.metadata}` 
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandImagesOem(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchBrandImagesFilters(action: actionsInterfaces.IFetchBrandImagesFiltersAction) {
  let token: string;
  try {    
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimagesfilters`    
    if(action.query)callUrl=`${host}brandsimagesfilters?filter=${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setBrandImagesFilters(response.data, action.typestate));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {    
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* getExternalImage(action: actionsInterfaces.IGetExternalImageAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}uploadExternalImage?url=${action.url}` 
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      //yield put(actions.brandsImages.setBrandLogos(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchCounter(action: actionsInterfaces.IFetchCounterAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}brandsimagescount`    
    if(action.filter)callUrl=`${host}brandsimagescount${action.filter}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.brandsImages.setCounterBrandImages(response.data[0], action.typestate));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeEvery(actionsTypes.FETCH_BRAND_IMAGES, fetchBrandImages),
    takeLatest(actionsTypes.FETCH_BRAND_IMAGE, fetchBrandImage),
    takeLatest(actionsTypes.ADD_BRAND_IMAGES, addBrandImages),
    takeEvery(actionsTypes.UPDATE_BRAND_IMAGES, updateBrandImages),
    takeEvery(actionsTypes.FETCH_BRAND_VEHICLES, fetchBrandsVehicles),
    takeEvery(actionsTypes.FETCH_BRAND_VEHICLESCHROMEDATA, fetchBrandsVehiclesChromeData),
    takeEvery(actionsTypes.FETCH_BRAND_LOGOS, fetchBrandsLogos),
    takeEvery(actionsTypes.FETCH_BRAND_IMAGES_OEM, fetchBrandsImagesOem),
    takeEvery(actionsTypes.FETCH_BRAND_IMAGES_FILTERS, fetchBrandImagesFilters),
    takeEvery(actionsTypes.GET_EXTERNAL_IMAGE, getExternalImage),
    takeLatest(actionsTypes.FETCH_COUNTER_BRAND_IMAGES, fetchCounter)
  ])
}

